/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：634
 */

var r = require(/* 476 */"../../1282/476")
module.exports = r("navigator", "userAgent") || ""
